var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggedIn)?_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }